/* eslint-disable @typescript-eslint/naming-convention */
import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';

export interface InvoiceApiModel {
    id: number;
    number: string;
    jobNumber: string;
    businessUnit: string;
    createdBy: string;
    status: string;
    subtotal: number;
    balance: number;
    total: number;
}

export interface EstimateApiModel {
    id: number;
    name: string;
    jobId: number;
    locationId: number;
    createdById: number;
    total: number;
    status: string;
    proposalTagName: string;
}

export interface JobDetailsApiModel {
    id: number;
    invoiceId?: number;
    customerId: number;
    businessUnitId: number;
    number: string;
    status: string;
    invoices: InvoiceApiModel[];
    estimates: EstimateApiModel[];
}

export type JobDetailsResponse = JobDetailsApiModel;

@injectable()
export class JobDetailsApi {
    constructor(private readonly httpClient: HttpClient) {}

    getJobDetails = (appointmentId: number, cancellationToken?: CancelToken) => {
        return this.httpClient.get<JobDetailsResponse>(`/api/v1/job-details/${appointmentId}`, {
            cancelToken: cancellationToken,
        });
    };
}
